import { fetchAPI, METHODS, parseBody } from './common';

export async function createInventoryItem(item) {
  const res = await fetchAPI('/inventory/item', METHODS.post, item);
  return parseBody(res);
}

export async function fetchInventoryItems({
  status,
  archived,
  search,
  limit,
  offset,
  eligibleForDonation,
} = {}) {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  if (archived === true) params.set('archived', 'true');
  if (search) params.set('search', search);
  if (limit) params.set('limit', String(limit));
  if (offset) params.set('offset', String(offset));
  if (eligibleForDonation) params.set('eligibleForDonation', 'true');
  const queryString = params.toString();
  const queryParams = queryString ? `?${queryString}` : '';
  const res = await fetchAPI(`/inventory/items${queryParams}`, METHODS.get);
  return parseBody(res);
}

export async function updateInventoryItem(id, item) {
  const res = await fetchAPI(`/inventory/item/${id}`, METHODS.put, item);
  return parseBody(res);
}

export async function toggleInventoryItemStatus(id) {
  const res = await fetchAPI(
    `/inventory/item/${id}/toggle-status`,
    METHODS.put
  );
  return parseBody(res);
}

export async function toggleArchiveStatus(id) {
  const res = await fetchAPI(
    `/inventory/item/${id}/toggle-archive`,
    METHODS.put
  );
  return parseBody(res);
}

export async function bulkImportInventoryItems({ items, stores }) {
  const res = await fetchAPI('/inventory/bulk-import', METHODS.post, {
    items,
    stores,
  });
  return parseBody(res);
}

export async function checkSkuUniqueness(sku) {
  const res = await fetchAPI('/inventory/check-sku', METHODS.post, { sku });
  return parseBody(res);
}

export async function checkSkusUniqueness(skus) {
  const res = await fetchAPI('/inventory/check-skus', METHODS.post, { skus });
  return parseBody(res);
}

export async function addStoreToInventoryItem(id) {
  const res = await fetchAPI(
    `/inventory/item/${id}/add-store`,
    METHODS.put,
    {}
  );
  return parseBody(res);
}

export async function setInventoryItemCorporateMaster(id) {
  const res = await fetchAPI(
    `/inventory/item/${id}/corporate-master`,
    METHODS.put,
    {
      is_corporate_master_item: true,
    }
  );
  return parseBody(res);
}

/**
 * Promotes a draft inventory item to a master item.
 * @param {string} id - The inventory item ID
 * @param {object} data - The promotion data
 * @param {string} data.sku - The SKU for the item
 * @param {number} data.cost_value_cents - The cost value in cents
 * @param {number} data.sale_value_cents - The sale value in cents
 * @returns {Promise<object>}
 */
export async function promoteDraftToMaster(
  id,
  { sku, cost_value_cents, sale_value_cents }
) {
  const res = await fetchAPI(`/inventory/item/${id}/promote`, METHODS.put, {
    sku,
    cost_value_cents,
    sale_value_cents,
  });
  return parseBody(res);
}
